import { ServerApiAccess } from "../server-api-access";

export type PdfConverterStatus =
  | 'LOADING'
  | 'EMPTY'
  | 'PENDING'
  | 'PROCESSING'
  | 'SUCCESS'
  | 'FAILURE'

export type PdfConverterParam = {
    domainId: string,
    topicId: string,
    messageId: string,
    commentId?: string,
    fileName: string,
}

export type PdfConverterStatusResponse = {
    pdfConverterStatus: PdfConverterStatus,
}

export type PdfAttachmentFileResponse = {
    fileUrl: string
}

export default class PdfConverterUtility {
    private static instance: PdfConverterUtility;

    public static getInstance(): PdfConverterUtility {
        if( !PdfConverterUtility.instance ) {
            this.instance = new PdfConverterUtility();
        }
        return this.instance;
    }

    /**
     * PDF変換ステータスの取得
     * @param param
     * @returns
     */
    public async getPdfConverterStatus(param: PdfConverterParam): Promise<PdfConverterStatusResponse|undefined> {
        try {
            const api = new ServerApiAccess();
            const results = await api.getPdfConverterStatus(param);
            if( results ) {
                return results;
            } else {
                console.error("Get PDF Converter Status Error :%O", results);
                return undefined;
            }
        } catch( error ) {
            console.error("Get PDF Converter Status Error :%O", error);
            return undefined;
        }
    }

    /**
     * PDF変換を開始
     * @param param
     * @returns
     */
    public async sendStartPdfConversion(param: PdfConverterParam): Promise<void> {
        try {
            const api = new ServerApiAccess();
            await api.sendStartPdfConversion(param);
        } catch( error ) {
            console.error("Send Start PDF Conversion Error :%O", error);
            return undefined;
        }
    }

    /**
     * 変換されたPDFファイルの取得
     * @param param
     * @returns
     */
    public async getPdfAttachmentFile(param: PdfConverterParam): Promise<PdfAttachmentFileResponse|undefined> {
        try {
            const api = new ServerApiAccess();
            const results = await api.getPdfAttachmentFile(param);
            if( results ) {
                return results;
            } else {
                console.error("Get PDF Attachment File Error :%O", results);
                return undefined;
            }
        } catch( error ) {
            console.error("Get PDF Attachment File Error :%O", error);
            return undefined;
        }
    }

}
